//Created by wangshuyi on 2021/7/20.

'use strict';
import dolphinCoreConfig from '../config';

export default {
  name: 'dol-boolean',
  functional: true,
  props: ['value', 'trueText', 'falseText', 'nullText'],
  render(h, { props, data, children }) {
    let text;
    let check = data.model ? data.model.value : props.value;
    if(check === undefined || check === null){
      text = props.nullText || dolphinCoreConfig.dolBoolean.nullText;
    }else if(check){
      text = props.trueText || dolphinCoreConfig.dolBoolean.trueText;
    }else{
      text = props.falseText || dolphinCoreConfig.dolBoolean.falseText;
    }

    return h('span', text);
  }
}
